import React from "react";
import { UIProperties } from "../UIProperties";

import './ProviderFeedbackUI.css'

const ProviderFeedbackUI = (props: UIProperties<ProviderFeedbackUIProps>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container modal-disable-select">
			<div className={"provider-container center-on-container provider-fade-" + props.parameters.fade}>
				<img src="./assets/images/general/components/general_alert/provider_window.png"/>
				<div className="provider-img-container">
					{props.parameters.img ? (<img src={"./assets/images/general/components/general_alert/" + props.parameters.img + ".png"}/>) : 
					(<div></div>)}
				</div>
				<div className="provider-desc-container">
					<p tabIndex={0} id='first-object-providerFeedback' className="provider-desc">{props.parameters.text}</p>
					{/* <p tabIndex={0} id='last-object-providerFeedback' aria-label='end of content'></p> */}
				</div>
			</div>
		</div>
	);
};

export interface ProviderFeedbackUIProps {
	text: string;
	img?: string;
	fade: string;
}

export default ProviderFeedbackUI;